import React from "react";
import {
  Box,
  Button,
  Hidden,
  IconButton,
  Inline,
} from "@origin-digital/ods-core";
import { FilterButtonResponsive } from "src/components/Premises";
import { ActionSectionProps } from "./types";
import PermissionsControlledWrapper from "src/components/Permissions/PermissionsControlledWrapper";
import { PermissionEnum } from "src/components/Permissions/types";
import { IconClose, IconPlus, IconSearch } from "@origin-digital/ods-icons";
import { SearchFieldResponsive } from "src/components/Form/SearchField";
import { useActionSection } from "./useActionSection";
import { useSearchAction } from "src/context/NewPremiseFormContext";

export const ActionSectionBelowMd = (props: ActionSectionProps) => {
  const {
    newPremisesButtonProps,
    claimDBRequestButtonProps,
    filterButtonProps,
  } = useActionSection(props);
  const {
    searchFieldProps,
    closeSearchIconButtonProps,
    openSearchIconButtonProps,
    searchFieldShown,
  } = useSearchAction();
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={["medium", "large"]}
      data-id="actionSection.root"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{
          xs: "row",
          lg: "row-reverse",
        }}
      >
        {/* New/claim premises */}
        <PermissionsControlledWrapper
          requiredPermission={PermissionEnum.CREATE_REQUEST}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            gap="small"
            data-id="actionSection.newOrClaimPremisesBox"
          >
            <Button
              size="small"
              icon={<IconPlus color="inherit" />}
              {...newPremisesButtonProps}
            >
              <Inline>
                {/* Allow Hidden for pure text */}
                <Hidden below="lg">New premises</Hidden>
                <Hidden above="lg">New</Hidden>
              </Inline>
            </Button>
            <Button
              size="small"
              variant="outlined"
              icon={<IconPlus color="inherit" />}
              {...claimDBRequestButtonProps}
            >
              <Inline>
                {/* Allow Hidden for pure text */}
                <Hidden below="lg">Claim DB Request</Hidden>
                <Hidden above="lg">Claim</Hidden>
              </Inline>
            </Button>
          </Box>
        </PermissionsControlledWrapper>
        {/* End New/claim premises */}
        {/* Filter/search */}
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          flexDirection={{
            xs: "row",
            lg: "row-reverse",
          }}
          gap={{
            xs: "xxxsmall",
            md: "medium",
          }}
          data-id="actionSection.filterAndSearchBox"
        >
          <FilterButtonResponsive {...filterButtonProps} />
          {/* End Filter (XS > MD) */}

          {/* Search (XS > MD) */}
          {searchFieldShown ? (
            <IconButton {...closeSearchIconButtonProps}>
              <IconClose aria-label="Close search" size="xsmall" />
            </IconButton>
          ) : (
            <IconButton {...openSearchIconButtonProps}>
              <IconSearch aria-label="Search" size="xsmall" />
            </IconButton>
          )}
          {/* End Search (XS > MD) */}
        </Box>
        {/* End Filter/search */}
      </Box>
      {searchFieldShown && <SearchFieldResponsive {...searchFieldProps} />}
    </Box>
  );
};
